import { DebitTypeObj, RupeeIcon } from '../common/constants/khataUtils';

export const GetType: React.FC<{ type: string }> = ({ type }): JSX.Element => {
    return (
        <div className="flex items-center space-x-6">
            <p>{DebitTypeObj[type]?.icon || <RupeeIcon />}</p>
            <p className="capitalize">{DebitTypeObj[type]?.text || type}</p>
        </div>
    );
};
